import type { DecodedSignedRequest } from "./types";

/**
 * Shared mutable session state for the Canvas signed-request cache.
 * Kept in its own module so both `authentication` and `testing` can
 * read/write it without creating a circular import between each other.
 *
 * The variables are intentionally NOT exported — all access goes through
 * the explicit getter/setter/clear functions below so no caller can mutate
 * the cache directly.
 */
let signedRequestPayload: DecodedSignedRequest | undefined;
let inflightRequest: Promise<DecodedSignedRequest> | null = null;

export function getSignedRequestPayload(): DecodedSignedRequest | undefined {
  return signedRequestPayload;
}

export function getInflightRequest(): Promise<DecodedSignedRequest> | null {
  return inflightRequest;
}

export function clearSessionState(): void {
  signedRequestPayload = undefined;
  inflightRequest = null;
}

export function setSignedRequestPayload(payload: DecodedSignedRequest): void {
  signedRequestPayload = payload;
}

export function setInflightRequest(req: Promise<DecodedSignedRequest> | null): void {
  inflightRequest = req;
}
